module.exports = __webpack_public_path__ + "img/logo.47d7d7ef.png";